import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const PlanovaneList = lazy(() =>
  import('@/modules/kontakty/PlanovaneList').then((m) => ({ default: m.PlanovaneList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/planovane',
  component: () => (
    <Suspense fallback={null}>
      <PlanovaneList />
    </Suspense>
  ),
});
